// extracted by mini-css-extract-plugin
export var button = "_ko-0";
export var donut = "_ko-1";
export var donutFill = "_ko-3";
export var donutTrack = "_ko-2";